import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import LinkListBlock, { type LinkListBlockProps } from '@helsenorge/core-cms/linklistblock';
import SearchField from '@helsenorge/core-cms/search-v2/search-field';

export interface LinkListBlockWithSearchProps extends LinkListBlockProps {
  search?: {
    searchUrl: string;
    label: string;
    submitLabel: string;
    contentReference: string;
    referrer: string;
  };
}

const LinkListBlockWithSearch: React.FunctionComponent<LinkListBlockWithSearchProps> = ({ search, ...rest }) => (
  <LinkListBlock {...rest}>
    {search && (
      <SearchField
        searchUrl={search.searchUrl}
        inputAriaLabel={search.label}
        submitButtonText={search.submitLabel}
        queryParams={{
          cr: search.contentReference,
          referrer: search.referrer,
        }}
      />
    )}
    <Spacer size={'l'} />
  </LinkListBlock>
);

export default LinkListBlockWithSearch;
